export default {
  errors: {
    archive: {
      insufficientPermissions: `Sorry, you don't have access to this page.`,
    },
    offsetReportUndefined: 'There was a problem accessing this offset report. Please contact a Head Office administrator.',
    mfiUndefined: 'There was a problem accessing the MFI of this offset report. Please contact a Head Office administrator.',
  },
}
